import UdeskLocales from 'UdeskLocales';
import React, { FC, memo, useCallback, useState } from 'react';
import { useRequest } from 'ahooks';
import { Button, Form, Input, message, Space, Spin } from 'udesk-ui';
import { FormWrapper, Wrapper } from './components';
import { getFeishuConfigs, postFeishuConfigs } from 'src/api/feishuConfigs';

interface FormValues {
    appId?: string;
    appSecret?: string;
    encryptKey?: string;
    verificationToken?: string;
}

interface TempalteProps {}

const Tempalte: FC<TempalteProps> = memo((props) => {
    const [form] = Form.useForm();

    const [initFormValues, setInitFormValues] = useState<FormValues>();

    const { run: refresh, loading: getLoading } = useRequest(() => getFeishuConfigs(), {
        onSuccess: (res) => {
            setInitFormValues({
                appId: res.data?.appId,
                appSecret: res.data?.appSecret,
                encryptKey: res.data?.encryptKey,
                verificationToken: res.data?.verificationToken,
            });
            form.resetFields();
        },
    });

    const onCancel = useCallback(() => {
        form.resetFields();
    }, [form]);

    const { run: onFinish, loading: postLoading } = useRequest(
        (values: FormValues) => postFeishuConfigs(values),
        {
            manual: true,
            onSuccess: () => {
                message.success(
                    /* 授权成功 */ UdeskLocales['current'].pages.systemIntegration.zendesk
                        .components.ticket.index.authorizationSucceeded
                );
                refresh();
            },
        }
    );

    return (
        <Wrapper>
            <Spin spinning={getLoading || postLoading}>
                <FormWrapper>
                    <Form
                        form={form}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 10 }}
                        initialValues={initFormValues}
                        onFinish={onFinish}
                        style={{ flex: 1 }}
                    >
                        <Form.Item name="appId" label="APP_ID" rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item name="appSecret" label="APP_SECRET" rules={[{ required: true }]}>
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item
                            name="encryptKey"
                            label="Encrypt_Key"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item
                            name="verificationToken"
                            label="Verification_Token"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={200} />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 10 }}>
                            <Space>
                                <Button onClick={onCancel}>
                                    {/* 取消 */}
                                    {
                                        UdeskLocales['current'].pages.systemIntegration.feishu.index
                                            .cancel
                                    }
                                </Button>

                                <Button key="applyAuth" type="primary" htmlType="submit">
                                    {/* 保存 */}
                                    {
                                        UdeskLocales['current'].pages.systemIntegration.feishu.index
                                            .preserve
                                    }
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </FormWrapper>
            </Spin>
        </Wrapper>
    );
});

export default Tempalte;
